const RESTITUTION_DETAILS = {
  header: 'Restituições',
  title: 'Resumo da Semana',
  defaultErrorMessage: 'Houve um erro, tente novamente mais tarde.',
  details: {
    title: 'Detalhamento',
    question: 'Dúvidas sobre a restituição?',
    helpLink:
      'https://ze-delivery-pdv.zendesk.com/hc/pt-br/articles/48845571056913-D%C3%BAvidas-sobre-a-restitui%C3%A7%C3%A3o',
    summaries: {
      markup: {
        title: 'Markup',
        subtitle: 'Markup na venda dos produtos Ambev.',
        helpLink:
          'https://faq-parceiro-zedelivery.sprinklr.com/articles/pagamento/como-calculada-a-restituio-do-markup/69fa42ee05f37d1b1c9f98ab',
        downloadButtonText: 'markup por pedido',
      },
      shipping: {
        title: 'Fretes',
        subtitle:
          'Diferença entre os valores de entrega negociado com você e os pagos pelo cliente, incluindo taxas adicionais.',
        helpLink:
          'https://ze-delivery-pdv.zendesk.com/hc/pt-br/articles/48845548448017-Como-%C3%A9-calculada-a-restitui%C3%A7%C3%A3o-dos-Fretes',
        downloadButtonText: 'frete por pedido',
      },
      couponAndDiscount: {
        title: 'Cupons e Descontos',
        subtitle: 'Valores de cupons e descontos aplicados nos pedidos.',
        helpLink:
          'https://ze-delivery-pdv.zendesk.com/hc/pt-br/articles/48845502988817-Como-s%C3%A3o-calculadas-as-restitui%C3%A7%C3%B5es-de-Cupons-e-Descontos',
        downloadButtonText: 'cupons e descontos por pedido',
      },
      incentive: {
        title: 'Incentivos',
        subtitle:
          'Valores operacionais pagos de acordo com as metas e indicadores atingidos.',
        helpLink:
          'https://ze-delivery-pdv.zendesk.com/hc/pt-br/articles/48845442517265-Como-s%C3%A3o-calculados-os-Incentivos',
        downloadButtonText: 'incentivos',
      },
      marketPlace: {
        title: 'Taxas e Comissões',
        subtitle: 'Detalhamento de cobranças como plataforma e marketplace.',
        detailsSummaryLabel: 'Comissão',
        helpLink:
          'https://ze-delivery-pdv.zendesk.com/hc/pt-br/articles/48845257164689-Como-s%C3%A3o-calculadas-as-Taxas-e-Comiss%C3%B5es',
        downloadButtonText: 'comissões por pedido',
      },
      manualPayment: {
        title: 'Pagamentos Manuais',
        subtitle:
          'Ajustes e correções de valores referentes a períodos passados ou atuais.',
        helpLink:
          'https://ze-delivery-pdv.zendesk.com/hc/pt-br/articles/48845205177105-Como-s%C3%A3o-calculados-os-Pagamentos-Manuais',
        downloadButtonText: 'pagamentos manuais',
      },
    },
  },
  detailsAccordion: {
    summaryLabel: 'Restituição',
    helpLinkText: 'Como esse valor foi calculado?',
    downloadReportPrefix: 'Baixar relatório',
    currentWeekMessage:
      'Valor ainda está sendo calculado. Não é possível ter uma pré-visualização antes do fechamento da semana.',
    noDetailsMessage:
      'Não há dados de restituição para a categoria na semana selecionada.',
    discountedValue:
      'Esse valor será descontado no cálculo total da restituição',
    notDiscountedValue:
      'Esse valor não será descontado no cálculo total da restituição',
    errorMessageCardTotalMismatch: 'Restitution details card total mismatch',
  },
  breadcrumb: {
    home: 'Restituições: Resumo das semanas',
    week: 'Semana',
  },
  actions: {
    print: 'Imprimir faturamento',
    download: 'Baixar relatório',
  },
  currentWeek: {
    warning:
      'Valores da página estão sendo atualizados. Essa semana ainda não foi fechada.',
  },
  summary: {
    status: 'Status:',
    previsionDate: 'Previsão de pagamento:',
    period: 'Período de vendas considerado:',
    orders: 'Pedidos',
    total: 'Valor restituído',
    fallback: '--',
    loading: 'Carregando resumo da semana...',
  },
  badge: {
    pending: 'Pendente',
    processed: 'Processado',
  },
  analytics: {
    report: 'Relatório',
    question: 'Dúvidas',
    componentCategory: {
      accordion: 'Accordion',
      breadcrumb: 'Breadcrumb',
      button: 'Button',
      textLink: 'TextLink',
    },
    componentName: {
      print: 'Imprimir faturamento',
      download: 'Baixar relatório',
      breadcrumb: 'Resumo',
    },
  },
}

export default RESTITUTION_DETAILS
